import { render, staticRenderFns } from "./OTPPage.vue?vue&type=template&id=e6e6fdd4&"
import script from "./OTPPage.vue?vue&type=script&lang=js&"
export * from "./OTPPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports